<!-- Bootstrap Dropdown -->
<div class="dropdown" [class.show]="isOpen">
  <!-- Trigger Icon Button -->
  <button class="btn nav-popup-trigger-icon dropdown-toggle"
    type="button"
    (click)="toggle()"
    [attr.aria-label]="isOpen ? 'Close navigation menu' : 'Open navigation menu'"
    [attr.aria-expanded]="isOpen">
    <i class="fa-solid fa-grip"></i>
  </button>

  <!-- Dropdown Menu -->
  <div class="dropdown-menu nav-popup-panel"
    [class.show]="isOpen"
    [@slideIn]>

    <!-- Search Bar -->
    <div class="search-section">
      <div class="search-box">
        <i class="fa-solid fa-search search-icon"></i>
        <input type="text"
          class="search-input"
          placeholder="Search..."
          [(ngModel)]="searchQuery"
          (input)="filterItems()"
          #searchInput>
      </div>
    </div>

    <div class="scrollable-content">
      <!-- Navigation Section -->
      @if (filteredNavItems.length > 0) {
        <div class="section">
          <h4 class="section-title">Navigation</h4>
          <nav class="section-items">
            @for (item of filteredNavItems; track item) {
              @if (shouldShowNavItem(item)) {
                <button
                  class="dropdown-item item"
                  [ngClass]="{
                    'disabled': isNavItemDisabled(item)
                  }"
                  (click)="navigate(item)"
                  [attr.aria-label]="item.label">
                  <i class="fa-solid {{item.icon}} item-icon"></i>
                  <span class="item-label">{{item.label}}</span>
                  @if (item.disabledInFreeTier && inFreeTier) {
                    <i class="fa-solid fa-lock lock-icon"></i>
                  }
                </button>
              }
            }

            <!-- Admin link (Kartorium staff only) -->
            @if (showAdminLink && (!searchQuery || 'admin'.includes(searchQuery.toLowerCase()))) {
              <button
                class="dropdown-item item item-admin"
                (click)="navigateToRoute('/admin/org-settings')"
                aria-label="Admin Settings">
                <i class="fa-solid fa-shield-halved item-icon"></i>
                <span class="item-label">Admin</span>
              </button>
            }
          </nav>
        </div>
      }

      <!-- Tools Section -->
      @if (filteredTools.length > 0 && showAISearch) {
        <div class="section">
          <h4 class="section-title">Tools</h4>
          <nav class="section-items">
            <button class="dropdown-item item item-tool"
              (click)="openSearchModal()"
              [attr.aria-label]="'AI Search'">
              <i class="fa-solid fa-search item-icon"></i>
              <span class="item-label">AI Search</span>
            </button>
          </nav>
        </div>
      }

      <!-- Recently Visited Section -->
      @if (!searchQuery && recentlyVisited.length > 0) {
        <div class="section">
          <h4 class="section-title">Recently Visited</h4>
          <nav class="section-items">
            @for (item of recentlyVisited; track item) {
              <button
                class="dropdown-item item recent-item"
                (click)="navigate(item)"
                [attr.aria-label]="item.label">
                <i class="fa-solid {{item.icon}} item-icon"></i>
                <span class="item-label">{{item.label}}</span>
                <span class="recent-time">{{item.visitedTime}}</span>
              </button>
            }
          </nav>
        </div>
      }

      <!-- No Results -->
      @if (filteredNavItems.length === 0 && filteredTools.length === 0 && searchQuery) {
        <div class="no-results">
          <i class="fa-solid fa-magnifying-glass"></i>
          <p>No results for "{{searchQuery}}"</p>
        </div>
      }
    </div>
  </div>
</div>

<!-- Click Outside to Close -->
@if (isOpen) {
  <div class="nav-popup-overlay"
  (click)="close()"></div>
}
